import { getLatestTerms, queryKeys } from "@dutyon/apis";
import { useQuery } from "@tanstack/react-query";

const SERVICE_TERMS_CATEGORY_KEY = "SERVICE_TERMS";
const MARKETING_TERMS_CATEGORY_KEY = "MARKETING";

export function useLatestLegalTerms(enabled: boolean) {
  const query = useQuery({
    queryKey: queryKeys.terms.latest(),
    queryFn: getLatestTerms,
    enabled,
    retry: false,
  });

  return {
    ...query,
    consentTerms: {
      service: query.data?.find(
        (terms) => terms.categoryKey === SERVICE_TERMS_CATEGORY_KEY && terms.isActive,
      ),
      marketing: query.data?.find(
        (terms) => terms.categoryKey === MARKETING_TERMS_CATEGORY_KEY && terms.isActive,
      ),
    },
  };
}
